<template>
  <!-- <header class="header">Sughosh Raviraj Jahagirdar</header> -->
  <header></header>
</template>

<script>
export default {};
</script>

<style scoped>
.header {
  font-size: 1.5rem;
  color: #fff;
  background: #333333;
  padding: 2rem 5rem 2rem 10rem;
}
</style>